/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardUsersRouteImport } from './routes/_dashboard/users'
import { Route as DashboardUploadRouteImport } from './routes/_dashboard/upload'
import { Route as DashboardResultsRouteImport } from './routes/_dashboard/results'
import { Route as DashboardQualityTestRouteImport } from './routes/_dashboard/quality-test'
import { Route as DashboardIaSetupRouteImport } from './routes/_dashboard/ia-setup'
import { Route as DashboardHomeRouteImport } from './routes/_dashboard/home'
import { Route as DashboardChatRouteImport } from './routes/_dashboard/chat'
import { Route as DashboardChartsRouteImport } from './routes/_dashboard/charts'
import { Route as DashboardShowcaseUserAdminPageRouteImport } from './routes/_dashboard/showcase/user-admin-page'
import { Route as DashboardShowcaseAdminPageRouteImport } from './routes/_dashboard/showcase/admin-page'
import { Route as DashboardShowcaseTabsIndexRouteImport } from './routes/_dashboard/showcase/tabs.index'
import { Route as DashboardShowcaseTabsTabRouteImport } from './routes/_dashboard/showcase/tabs.$tab'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsersRoute = DashboardUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardUploadRoute = DashboardUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardResultsRoute = DashboardResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardQualityTestRoute = DashboardQualityTestRouteImport.update({
  id: '/quality-test',
  path: '/quality-test',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardIaSetupRoute = DashboardIaSetupRouteImport.update({
  id: '/ia-setup',
  path: '/ia-setup',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardHomeRoute = DashboardHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardChatRoute = DashboardChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardChartsRoute = DashboardChartsRouteImport.update({
  id: '/charts',
  path: '/charts',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardShowcaseUserAdminPageRoute =
  DashboardShowcaseUserAdminPageRouteImport.update({
    id: '/showcase/user-admin-page',
    path: '/showcase/user-admin-page',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardShowcaseAdminPageRoute =
  DashboardShowcaseAdminPageRouteImport.update({
    id: '/showcase/admin-page',
    path: '/showcase/admin-page',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardShowcaseTabsIndexRoute =
  DashboardShowcaseTabsIndexRouteImport.update({
    id: '/showcase/tabs/',
    path: '/showcase/tabs/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardShowcaseTabsTabRoute =
  DashboardShowcaseTabsTabRouteImport.update({
    id: '/showcase/tabs/$tab',
    path: '/showcase/tabs/$tab',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/charts': typeof DashboardChartsRoute
  '/chat': typeof DashboardChatRoute
  '/home': typeof DashboardHomeRoute
  '/ia-setup': typeof DashboardIaSetupRoute
  '/quality-test': typeof DashboardQualityTestRoute
  '/results': typeof DashboardResultsRoute
  '/upload': typeof DashboardUploadRoute
  '/users': typeof DashboardUsersRoute
  '/showcase/admin-page': typeof DashboardShowcaseAdminPageRoute
  '/showcase/user-admin-page': typeof DashboardShowcaseUserAdminPageRoute
  '/showcase/tabs/$tab': typeof DashboardShowcaseTabsTabRoute
  '/showcase/tabs/': typeof DashboardShowcaseTabsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/charts': typeof DashboardChartsRoute
  '/chat': typeof DashboardChatRoute
  '/home': typeof DashboardHomeRoute
  '/ia-setup': typeof DashboardIaSetupRoute
  '/quality-test': typeof DashboardQualityTestRoute
  '/results': typeof DashboardResultsRoute
  '/upload': typeof DashboardUploadRoute
  '/users': typeof DashboardUsersRoute
  '/showcase/admin-page': typeof DashboardShowcaseAdminPageRoute
  '/showcase/user-admin-page': typeof DashboardShowcaseUserAdminPageRoute
  '/showcase/tabs/$tab': typeof DashboardShowcaseTabsTabRoute
  '/showcase/tabs': typeof DashboardShowcaseTabsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_dashboard/charts': typeof DashboardChartsRoute
  '/_dashboard/chat': typeof DashboardChatRoute
  '/_dashboard/home': typeof DashboardHomeRoute
  '/_dashboard/ia-setup': typeof DashboardIaSetupRoute
  '/_dashboard/quality-test': typeof DashboardQualityTestRoute
  '/_dashboard/results': typeof DashboardResultsRoute
  '/_dashboard/upload': typeof DashboardUploadRoute
  '/_dashboard/users': typeof DashboardUsersRoute
  '/_dashboard/showcase/admin-page': typeof DashboardShowcaseAdminPageRoute
  '/_dashboard/showcase/user-admin-page': typeof DashboardShowcaseUserAdminPageRoute
  '/_dashboard/showcase/tabs/$tab': typeof DashboardShowcaseTabsTabRoute
  '/_dashboard/showcase/tabs/': typeof DashboardShowcaseTabsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/unauthorized'
    | '/charts'
    | '/chat'
    | '/home'
    | '/ia-setup'
    | '/quality-test'
    | '/results'
    | '/upload'
    | '/users'
    | '/showcase/admin-page'
    | '/showcase/user-admin-page'
    | '/showcase/tabs/$tab'
    | '/showcase/tabs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/unauthorized'
    | '/charts'
    | '/chat'
    | '/home'
    | '/ia-setup'
    | '/quality-test'
    | '/results'
    | '/upload'
    | '/users'
    | '/showcase/admin-page'
    | '/showcase/user-admin-page'
    | '/showcase/tabs/$tab'
    | '/showcase/tabs'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/login'
    | '/unauthorized'
    | '/_dashboard/charts'
    | '/_dashboard/chat'
    | '/_dashboard/home'
    | '/_dashboard/ia-setup'
    | '/_dashboard/quality-test'
    | '/_dashboard/results'
    | '/_dashboard/upload'
    | '/_dashboard/users'
    | '/_dashboard/showcase/admin-page'
    | '/_dashboard/showcase/user-admin-page'
    | '/_dashboard/showcase/tabs/$tab'
    | '/_dashboard/showcase/tabs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/users': {
      id: '/_dashboard/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof DashboardUsersRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/upload': {
      id: '/_dashboard/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof DashboardUploadRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/results': {
      id: '/_dashboard/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof DashboardResultsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/quality-test': {
      id: '/_dashboard/quality-test'
      path: '/quality-test'
      fullPath: '/quality-test'
      preLoaderRoute: typeof DashboardQualityTestRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/ia-setup': {
      id: '/_dashboard/ia-setup'
      path: '/ia-setup'
      fullPath: '/ia-setup'
      preLoaderRoute: typeof DashboardIaSetupRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/home': {
      id: '/_dashboard/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof DashboardHomeRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/chat': {
      id: '/_dashboard/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof DashboardChatRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/charts': {
      id: '/_dashboard/charts'
      path: '/charts'
      fullPath: '/charts'
      preLoaderRoute: typeof DashboardChartsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/showcase/user-admin-page': {
      id: '/_dashboard/showcase/user-admin-page'
      path: '/showcase/user-admin-page'
      fullPath: '/showcase/user-admin-page'
      preLoaderRoute: typeof DashboardShowcaseUserAdminPageRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/showcase/admin-page': {
      id: '/_dashboard/showcase/admin-page'
      path: '/showcase/admin-page'
      fullPath: '/showcase/admin-page'
      preLoaderRoute: typeof DashboardShowcaseAdminPageRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/showcase/tabs/': {
      id: '/_dashboard/showcase/tabs/'
      path: '/showcase/tabs'
      fullPath: '/showcase/tabs/'
      preLoaderRoute: typeof DashboardShowcaseTabsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/showcase/tabs/$tab': {
      id: '/_dashboard/showcase/tabs/$tab'
      path: '/showcase/tabs/$tab'
      fullPath: '/showcase/tabs/$tab'
      preLoaderRoute: typeof DashboardShowcaseTabsTabRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardRouteRouteChildren {
  DashboardChartsRoute: typeof DashboardChartsRoute
  DashboardChatRoute: typeof DashboardChatRoute
  DashboardHomeRoute: typeof DashboardHomeRoute
  DashboardIaSetupRoute: typeof DashboardIaSetupRoute
  DashboardQualityTestRoute: typeof DashboardQualityTestRoute
  DashboardResultsRoute: typeof DashboardResultsRoute
  DashboardUploadRoute: typeof DashboardUploadRoute
  DashboardUsersRoute: typeof DashboardUsersRoute
  DashboardShowcaseAdminPageRoute: typeof DashboardShowcaseAdminPageRoute
  DashboardShowcaseUserAdminPageRoute: typeof DashboardShowcaseUserAdminPageRoute
  DashboardShowcaseTabsTabRoute: typeof DashboardShowcaseTabsTabRoute
  DashboardShowcaseTabsIndexRoute: typeof DashboardShowcaseTabsIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardChartsRoute: DashboardChartsRoute,
  DashboardChatRoute: DashboardChatRoute,
  DashboardHomeRoute: DashboardHomeRoute,
  DashboardIaSetupRoute: DashboardIaSetupRoute,
  DashboardQualityTestRoute: DashboardQualityTestRoute,
  DashboardResultsRoute: DashboardResultsRoute,
  DashboardUploadRoute: DashboardUploadRoute,
  DashboardUsersRoute: DashboardUsersRoute,
  DashboardShowcaseAdminPageRoute: DashboardShowcaseAdminPageRoute,
  DashboardShowcaseUserAdminPageRoute: DashboardShowcaseUserAdminPageRoute,
  DashboardShowcaseTabsTabRoute: DashboardShowcaseTabsTabRoute,
  DashboardShowcaseTabsIndexRoute: DashboardShowcaseTabsIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
